<template>
  <router-link :to="url">
    <div class="icon" @click="handleClick">
      <img :src="src"/>
      <div><slot></slot></div>
    </div>
  </router-link>
</template>

<script>
export default {
  name : 'Aicon',
  props: {
    src:String,
    url:String,
    text:String
  },
  data(){
    return {
    }
  },
  methods:{
    handleClick(event){
      this.$emit('on-click',event);
    }
  }
}
</script>

<style scoped>
  .icon {
    box-sizing:border-box;
    width: 100px;
    text-align: center;
    opacity: .6
  }
  .iconSelected,.icon:hover{
    cursor: pointer;
    opacity: 1;
    background: #E5F3FF;
    border:rgb(190, 225, 255) 1px solid;
  }
  img {
    height: 40px;
  }
  a {
    text-decoration: none;
    color: black
  }
</style>


// WEBPACK FOOTER //
// src/components/Alayout/Aicon/Aicon.vue